import type React from 'react';
import type { BaseProps } from 'src/types';

type ReactTooltipProps = React.ComponentProps<typeof import('react-tooltip').Tooltip>;

/**
 * Enum of allowed tooltip placements. Mirrors `react-tooltip` placements.
 * @public
 */
export enum TooltipPlace {
  TOP = 'top',
  RIGHT = 'right',
  BOTTOM = 'bottom',
  LEFT = 'left',
}

/**
 * Props for the `Tooltip` component. Proxies `react-tooltip` while enforcing local conventions.
 * - Extends `BaseProps` for consistency across components
 * - Defaults `place` to `TooltipPlace.BOTTOM`
 * @public
 */
export interface TooltipProps extends Omit<ReactTooltipProps, 'place' | 'children'>, Omit<BaseProps<HTMLDivElement>, 'children'> {
  /**
   * Preferred placement of the tooltip relative to its anchor.
   * Defaults to `TooltipPlace.BOTTOM`.
   */
  place?: TooltipPlace;
}
